"use client";

import Navbar from "../components/navbar";
import Preloader from "../components/preloader";
import About from "../components/sections/about";
import Hero from "../components/sections/hero";
import Mission from "../components/sections/mission";
import FounderProjects from "../components/sections/projects";
import ServicesSection from "../components/sections/services";
import OurSolutions from "../components/sections/solutions";
import Vision from "../components/sections/vision";
import WhyChooseLogicHub from "../components/sections/WhyChooseLogicHub";
import {
  useGetAboutUs,
  useGetCycle,
  useGetFounder,
  useGetServices,
  useGetSolutions,
  useGetVision,
  useGetWhyChoose,
} from "../hooks/main-hooks";
import Footer from "../components/footer";
import ContactSection from "../components/sections/contact";

export default function Home() {
  const { isLoading } = useGetAboutUs();
  const { isLoading: loadingWhyChoose } = useGetWhyChoose();
  const { isLoading: loadingCycle } = useGetCycle();
  const { isLoading: loadingVision } = useGetVision();
  const { isLoading: loadingServices } = useGetServices();
  const { isLoading: loadingSolutions } = useGetSolutions();
  const { isLoading: loadingFounder } = useGetFounder();

  const showPreloader =
    isLoading ||
    loadingWhyChoose ||
    loadingCycle ||
    loadingVision ||
    loadingServices ||
    loadingSolutions ||
    loadingFounder;

  if (showPreloader) {
    return <Preloader />;
  }

  return (
    <div className="overflow-hidden bg-linear-to-b from-background via-background to-[#1a1f3a]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <WhyChooseLogicHub />
        <Vision />
        <Mission />
        <ServicesSection />
        <OurSolutions />
        {/* <Clients /> */}
        <FounderProjects />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
